import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const ChooseLaravel: React.FC<Props> = ({ title}) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary fw-400">
              Laravel is the best open-source PHP framework because it has advanced features and can create highly scalable solutions. We provide various custom Laravel app development services by leveraging the remarkable features and functionalities of Laravel and its MVC (Model View Controller) architecture. </p>

              <p className="fs-md text-secondary fw-400">
              The Laravel application framework includes expressive and elegant syntax. It facilitates development by simplifying common challenges in the majority of web projects, such as sessions, authentication, caching, and routing.</p>

              <p className="fs-md text-secondary mb-0 fw-400">
              Moweb is a top-rated Laravel Development Company adhering to agile SDLC methodology to build enterprise-grade Laravel solutions. We consistently deliver high-quality PHP Laravel development projects with the best resources and practices for clients to get the most out of their investments.
              </p>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-9">
             <p className="fs-md text-secondary fw-400 mb-2.5">
            Some noteworthy Laravel features we integrate when developing web and mobile apps are –
          </p>
          <div className="row grid grid-cols-2">
          <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Template engine" />
              <KEYBlue text="Blade template engine " />
              <KEYBlue text=" Security" />
              <KEYBlue text="Great documentation " />
              <KEYBlue text=" Database query builder" />
              <KEYBlue text="Community-driven libraries " />
              <KEYBlue text=" Composer-friendly" />
              <KEYBlue text=" Unit-testing" />
              <KEYBlue text=" Dependency injection" />
              <KEYBlue text=" Modular Packing System" />
            </div>
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text=" Eloquent ORM" />
              <KEYBlue text=" MVC architecture support" />
              <KEYBlue text="Easy to attach middleware " />
              <KEYBlue text="Repository pattern " />
              <KEYBlue text=" URL routing configuration" />
              <KEYBlue text=" Friendly API" />
              <KEYBlue text="Artisan CLI and scaffolding " />
              <KEYBlue text="Database migrations, seeders " />
              <KEYBlue text=" Cross-Site Request Forgery" />
              <KEYBlue text="RESTful Resource Controllers " />
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ChooseLaravel
